import React from 'react'
import { connect } from 'react-redux';
import styles from './ScanStation.module.css'
import { PatientHomeScanEntry } from 'PatientCareCenter/Home/ScanStation'
import { ScrollDiv } from '_components';

class PatientHomeScanStation extends React.Component {

    render() {
        let oddEven = 0;
        return (
            <div className={styles.scan_wrapper}>
                <div className={styles.scan_header}>
                    <div className={styles.spacer}></div>
                    <div className={styles.date}>Date</div>
                    <div className={styles.type}>Type</div>
                    <div className={styles.notes}>Notes</div>
                    <div className={styles.user}>Added By</div>
                </div>
                <ScrollDiv divId={this.props.ptno + '_PCC_HOME_SCAN'} className={styles.scan_body}>
                    {Object.keys(this.props.scanEntries).length === 0 &&
                        <span className={styles.no_entries}>No Scanned Items.</span>
                    }
                    {Object.keys(this.props.scanEntries)
                        .map(id => {
                            const result = this.props.scanEntries[id];
                            return (
                                <span key={result.id} className={styles.scan_entry} style={{ backgroundColor: (oddEven++ % 2) === 0 ? '#e6f9ff' : 'transparent' }}>
                                    <PatientHomeScanEntry id={result.id} />
                                </span>
                            )
                        })
                    }
                </ScrollDiv>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        scanEntries: Object.keys(state.entities.scans)
            .filter(key => { return state.entities.scans[key].ptno === state.ui.patients.selectedPtno })
            .sort((a, b) => {
                return new Date(state.entities.scans[a].date).getTime() > new Date(state.entities.scans[b].date).getTime() ? -1 : 1;
            })
            .map(key => state.entities.scans[key]),
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientHomeScanStation = connect(mapStateToProps)(PatientHomeScanStation);
export { connectedPatientHomeScanStation as PatientHomeScanStation };